function isTargetWithinRole(target, role) {
  if (!target || typeof target?.closest !== "function") {
    return false;
  }

  return Boolean(target.closest(`[role="${role}"]`));
}

function isEditableEventTarget(target) {
  if (!target) {
    return false;
  }

  const tagName = String(target?.tagName ?? "").toLowerCase();
  if (tagName === "input" || tagName === "textarea" || tagName === "select") {
    return true;
  }

  return target.isContentEditable === true;
}

function isTargetWithinElement(target, element) {
  if (!target || !element || typeof element?.contains !== "function") {
    return false;
  }

  return element.contains(target);
}

export function resolveFoodPickerPanelKeyAction({
  event,
  activeElement = null,
  panelElement = null,
  isTopMost = true,
} = {}) {
  if (event?.key !== "Escape") {
    return null;
  }

  const resolvedIsTopMost =
    typeof isTopMost === "function" ? isTopMost() : isTopMost;
  if (!resolvedIsTopMost) {
    return null;
  }

  if (
    isTargetWithinRole(event?.target, "menu") ||
    isTargetWithinRole(activeElement, "menu")
  ) {
    return null;
  }

  const resolvedPanelElement =
    typeof panelElement === "function" ? panelElement() : panelElement;
  const focusIsWithinPanel =
    isTargetWithinElement(event?.target, resolvedPanelElement) ||
    isTargetWithinElement(activeElement, resolvedPanelElement);

  if (
    !focusIsWithinPanel &&
    (isEditableEventTarget(event?.target) || isEditableEventTarget(activeElement))
  ) {
    return null;
  }

  return "close";
}
